/* This file is a bit old now! */

import React from "react";
import { connect } from "react-redux";
import { isEmailValid, submitEmail } from "./optin-utilities";
import {
  setSeenModalInLocalstorage,
  setHasSignedUpInLocalstorage
} from './optin-localstorage-operations'


class OptinBox extends React.Component {
  constructor() {
    super();

    this.state = {
      currentValidationErrors: []
    };
  }

  componentDidMount() {
    //Mark that we've seen this before!
    setSeenModalInLocalstorage();
  }

  handleSubmit(e) {
    if (e) {
      e.preventDefault();
    }
    const inputValue = this.refs.input.value;

    this.setState({
      currentValidationErrors: [] //Reset the errors
    });

    if (isEmailValid(inputValue)) {
      submitEmail(inputValue, () => {

        ///Mark that we've signed up before!
        setHasSignedUpInLocalstorage();

        //Call the success callback!
        if (this.props.successCallback) {
          this.props.successCallback();
        }
      });
      return;
    }

    //Email was not valid. Add errors
    this.setState({
      currentValidationErrors: ["Please enter a valid email address!"]
    });
  }

  handleButtonClick(e) {
    e.preventDefault();
    this.handleSubmit();
  }

  render() {
    const labelStyle = {
      fontSize: "1em",
      display: "block",
      marginBottom: "1.5em",
      color: "#5F506A",
      marginLeft: "2%"
    };
    const inputStyle = {
      // display: "block",
      width: "96%",
      textAlign: "left",
      paddingLeft: "1em"
      // fontSize: vW * 5,
      // height: vW * 12,
      // fontFamily: "Source Code Pro, monospace",
      // paddingLeft: vW,
      // border: `${vW / 4}px solid #999`,
      // borderRadius: 0,
      // marginBottom: vW
    };
    const submitStyle = {

    };
    const errorStyle = {
      color: "red",
      fontSize: "1em",
      padding: "3em 0 0"
    };

    /* eslint jsx-a11y/href-no-hash: "off" */
    return (
      <form onSubmit={this.handleSubmit.bind(this)} noValidate={true}>
        <label style={labelStyle}>Email Address</label>
        <div>
          <input ref="input" className="NameTextInput" style={inputStyle} type="email" />
          <div style={{marginTop: "2em"}}>
            <a href="#" onClick={this.handleButtonClick.bind(this)} className="button block primary large" style={submitStyle}>
              <span className="button--text">Submit</span>
            </a>
          </div>
        </div>
        {this.state.currentValidationErrors.map((errorString, i) => {
          return (
            <div key={i} style={errorStyle}>
              {errorString}
            </div>
          );
        })}
      </form>
    );
  }
}

export default connect((state, props) => {
  return {
  };
})(OptinBox);



// WEBPACK FOOTER //
// ./src/battle-optin/OptinForm.js